module.exports = __webpack_public_path__ + "static/media/attributes-info.daeeede4.svg";